import { keyframes, styled, css } from '@vebox/etui-system';
import { createElement } from 'react';
import { Div } from '@vebox/etui-system-elements';
import { darken } from '@vebox/etui-colors';

const pulse = keyframes`
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -75% 0%;
    }
`;
const SkeletonPulse = styled(Div)`
  display: block;
  border-radius: 2px;
  background: ${() => css`
    linear-gradient(
      -90deg,
      ${darken('#fafcfc', 0.06)} 0%,
      ${darken('#f2f5f5', 0.025)} 50%,
      ${darken('#f2f5f5', 0.05)} 100%
    );
  `};
  background-size: 400% 400%;
  animation: ${pulse} 1.4s ease-in-out infinite;
  ${({
  opacity
}) => css`
    opacity: ${opacity};
  `};
`;

const SkeletonLoader = props => {
  return /*#__PURE__*/createElement(SkeletonPulse, props);
};

export default SkeletonLoader;
